import { withValidation } from '../../validations';
const langSDKFactory = ({ setProps, props, }) => ({
    get lang() {
        return props.lang;
    },
    set lang(_lang) {
        setProps({
            lang: _lang,
        });
    },
});
export const createLangSDK = withValidation(langSDKFactory, {
    type: ['object'],
    properties: {
        lang: {
            type: ['string'],
        },
    },
});
//# sourceMappingURL=langSDKFactory.js.map